import React from 'react'
import styles from './UIGameTradeCreatorProposal.module.scss'
import {type CardEnum} from '@colonist/game-states'
import clsx from 'clsx'
import {UIGameTradeCreatorProposalWantedHalf} from './UIGameTradeCreatorProposalWantedHalf.tsx'
import {UIGameTradeCreatorProposalOfferedHalf} from './UIGameTradeCreatorProposalOfferedHalf.tsx'

export interface UIGameTradeCreatorProposalProps {
    className?: string | undefined
    offeredCards: CardEnum[]
    wantedCards: CardEnum[]
    onClickOfferedCard: (card: CardEnum) => void
    onClickWantedCard: (card: CardEnum) => void
    isPortraitLayout?: boolean | undefined
}

export const UIGameTradeCreatorProposal = ({
    className,
    offeredCards,
    wantedCards,
    onClickOfferedCard,
    onClickWantedCard,
    isPortraitLayout,
}: UIGameTradeCreatorProposalProps) => (
    <div className={clsx(styles.tradeCreatorProposalContainer, className, {
        [styles.portraitLayout]: isPortraitLayout,
    })}>
        <UIGameTradeCreatorProposalWantedHalf
            wantedCards={wantedCards}
            onClickWantedCard={onClickWantedCard}
            isPortraitLayout={isPortraitLayout}/>
        <UIGameTradeCreatorProposalOfferedHalf
            offeredCards={offeredCards}
            onClickOfferedCard={onClickOfferedCard}
            isPortraitLayout={isPortraitLayout}/>
    </div>
)
